export default "__VITE_ASSET__DaW_1qHP__"